module.exports = __webpack_public_path__ + "img/niigata-kotsu.cf71d21d.jpg";